import { render, staticRenderFns } from "./chat-action-items.vue?vue&type=template&id=67b4ec8c&scoped=true"
import script from "./chat-action-items.vue?vue&type=script&lang=js"
export * from "./chat-action-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b4ec8c",
  null
  
)

export default component.exports